import Dispatcher from '../../dispatcher';
import { ReduceStore } from 'flux/utils';
import { actionTypes } from '../../constants/action_types';
import { actions } from '../../constants/sidebar/actions';

const { SIDEBAR_ACTION } = actionTypes;
const { SHOW_LIGHT_BOX, HIDE_LIGHT_BOX } = actions;

class LightBoxClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
        };
    }

    reduce( state, { source, action }) {
        return (
            source === SIDEBAR_ACTION
                ? this.reduceSidebarAction( state, action )
                : state
        );
    }

    reduceSidebarAction( state, { type }) {
        return (
            type === SHOW_LIGHT_BOX
                ? this.handleShowAction( state )

            : type === HIDE_LIGHT_BOX
                ? this.handleHideAction( state )

            : state
        );
    }

    handleShowAction( state ) {
        if ( !state.visible ) {
            state.visible = true;
            this.__emitChange();
        }

        return state;
    }

    handleHideAction( state ) {
        if ( state.visible ) {
            state.visible = false;
            this.__emitChange();
        }

        return state;
    }
}

export const LightBox = new LightBoxClass( Dispatcher );
